import React from 'react'
import { Container } from '@material-ui/core';

const HomePage = () => {
    return (
        <div className="home-container">
        <div className="banner-section">
        <Container><div className="banner-content-container clearfix"><h1 className="">Welcome to MyDigital</h1>
       <p>MyDigital is the home of Matilda's best-in-class digital resources for teachers and students.</p>
       </div>
       </Container>
       </div>
       <Container> 
       <div  className="section-left goals" >
        <h2>Our goal</h2>
        <p>Matilda is proud to provide teachers and students with a best in class digital platform and enhanced eBooks.</p>
        <ul>
            <li>Purposeful, blended content that elevates teaching and learning</li>
            <li>Easy to find and easy to integrate</li>
            <li>Mapped to print product for seamless integration</li>
            <li>Engaging and multi-modal</li>
            <li>Time-saving for both teachers and students</li>
            <li>Pedagogically sound and tightly aligned to the syllabus</li>
            <li>Supports collaboration between students and teachers</li>
        </ul>
       </div>
       <div className="section-left goal-support">
        <h3>Teacher support</h3>
        <p className="home-teacher-support">Matilda teacher support is focused on classroom implementation and will help you make every lesson a good lesson.</p><p> Our philosophy is simple: Matilda digital implementation materials will make your job easier. We won’t make your job harder by giving you hundreds of files to download. Instead, our just-in-time, on-demand approach will help to empower you lesson-by-lesson.</p>
       
       <h3 className="student-support-header">Student support</h3>
       <p className="home-student-support">Students can access their textbooks online or offline at any time. They can take notes, save bookmarks, access audio, video and interactive activities to enrich their learning experience.</p>
       </div>

       </Container>
    </div>

    )
}

export default HomePage
